export default "__VITE_ASSET__DC3r81MW__"